import type { BookingSessionBundle } from '@VelocitySquared/sunny16-content-dataobjects-cady/booking'

import { elitePlusDetailModalFallback } from '@/content/sessionCatalogBundles/sessionDetailModalFallbacks'

export const elitePlusBundleFallback: BookingSessionBundle = {
  internalName: 'Bundle: Elite Plus',
  identifier: '',
  title: 'Elite Plus',
  orderSummaryFriendlyName: '',
  tagline: '',
  features: '',
  highlightedFeatures: '',
  listingImage: { assetId: '', alt: '', width: 0, height: 0, url: '' },
  listingImageMobile: { assetId: '', alt: '', width: 0, height: 0, url: '' },
  badgeLabel: '',
  ctaLabel: '',
  priceLabel: '',
  showPrice: true,
  selectLabel: '',
  recommendedLabel: '',
  galleryLabel: '',
  detailsLabel: '',
  detailPageSlug: '',
  includedScenesLabel: '',
  cartSummaryFeatures: '',
  comparisonItems: [] as never,
  galleryImages: [] as never,
  upgradeModal: null,
  sessionsListingUpgradeModal: null,
  sceneSelectionPage: null,
  addOnsSelectionPage: null,
  detailPage: null,
  sessionDetailModal: elitePlusDetailModalFallback
} as unknown as BookingSessionBundle
